module.exports = __webpack_public_path__ + "static/media/arrow-vertical.7d791c92.svg";